/**
 * Top FAQ: toggle accordion item
 */
const faqAccordion = () => {
  const items = document.querySelectorAll('.js-accordion-item');  
  
  items.forEach(item => {
    item.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  });
};

export default faqAccordion;